<template>
  <a-modal
          title="污染物标准"
          okText="确认"
          cancelText="取消"
          width="1500px"
          :visible="visible"
          :confirm-loading="confirmLoading"
          @ok="handleOk"
          @cancel="handleCancel"
  >
    <a-form-model ref="ruleForm" :model="formState" :rules="rules" :label-col="{span:8}" :wrapper-col="{span:16}">
      <a-row>
        <a-col span="24">
          <a-form-model-item :classifyId="param.classifyId" :labelCol="{span:0}" :wrapperCol="{span:24}" prop="badDicList">
            <a-ext-bad-dic-choice v-model="formState.badDicList"></a-ext-bad-dic-choice>
          </a-form-model-item>
        </a-col>
      </a-row>

    </a-form-model>

  </a-modal>
</template>

<script>

import AExtBadDicChoice from '../../../components/AntDesignExt/All/AExtBadDicChoice'
import {addRel as saveApi} from '../../../api/api'
export default {
    name: "FormModel",
    components:{
        AExtBadDicChoice,},
    props:{
        visible:{
            type:Boolean,
            default:false
        },
        param:{
            type:Object,
            default: ()=>{
                return {}
            }
        },
    },
    data() {
        return {
            confirmLoading: false,
            formState: {
                badDicList:[],
            },
            rules: {
                // badDicList: FormRules.withName('选择污染物').string(1, 200).isRequired().create(),
            },

        };
    },
    created(){
        this.initForm();
    },
    methods: {
        initForm(){

        },
        handleOk(e) {
            if(this.formState.badDicList&&this.formState.badDicList.length) {
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        this.confirmLoading = true;
                        saveApi({
                            classifyId: this.param.classifyId,
                            badDicList: this.formState.badDicList
                        }).then((result => {
                            this.confirmLoading = false;
                            this.$emit("addBadItemModalClose", true)
                            this.$emit("update:visible", false)
                        })).catch(() => {
                            this.confirmLoading = false;
                        });
                    } else {
                        return false;
                    }
                });
            }
            else{
                this.$emit("update:visible",false)
            }
        },
        handleCancel(e) {
            this.$emit("update:visible",false)
        },

    },
}
</script>

<style scoped lang="scss">

  /deep/ .ant-modal-body{
    /*height: 60vh;*/
    /*overflow-y: scroll;*/
  }

</style>